import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Heading, TextLink } from "@cinch-labs/design-system";
import { EventNames, TrackingEventTypes, useAnalytics } from "@cinch-nx/shared-analytics";
import { useRouter } from "next/router";
import styles from "./link-list.module.css";
export var LinkList = function(param) {
    var title = param.title, linkItems = param.linkItems;
    var router = useRouter();
    var trackEvent = useAnalytics().trackEvent;
    var handleClick = function(item) {
        trackEvent({
            eventName: "Links Section clicked",
            type: TrackingEventTypes.ADOBE,
            data: {
                event: {
                    name: EventNames.click,
                    category: item.text,
                    label: "".concat(item.text, " link"),
                    action: "manual links"
                }
            }
        });
        router.push(item.url);
    };
    return /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            /*#__PURE__*/ _jsx(Heading, {
                className: styles.sectionTitle,
                children: title
            }),
            /*#__PURE__*/ _jsx("ul", {
                className: styles.list,
                children: linkItems === null || linkItems === void 0 ? void 0 : linkItems.map(function(item) {
                    return /*#__PURE__*/ _jsx("li", {
                        className: styles.listItem,
                        onClick: function() {
                            return handleClick(item);
                        },
                        children: /*#__PURE__*/ _jsx(TextLink, {
                            hasNoLine: true,
                            href: item.url,
                            children: item.text
                        })
                    }, item.text);
                })
            })
        ]
    });
};
export default LinkList;
